import React, { FC } from 'react';
import { Box, Group, Text } from '@mantine/core';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { EllipsisTooltip } from '@components/EllipsisTooltip';

interface ITagList {
  Name: string;
  Id: number;
  Count: number;
}

interface ITextFieldProps {
  title: string;
  tags?: ITagList[];
}

export const TextFieldTags: FC<ITextFieldProps> = ({ title, tags }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Text className={classes.title}>{title}</Text>
      <Box className={classes.group}>
        <Box className={cx(classes.description)}>
          <Group gap="xs">
            {Array.isArray(tags) && tags.length > 0
              ? tags.map((item, index) => (
                  <EllipsisTooltip
                    key={index}
                    width={190}
                    data-text={item.Name}
                    className={classes.rounded}
                  >
                    {item.Name}
                  </EllipsisTooltip>
                ))
              : t('noInformation')}
          </Group>
        </Box>
      </Box>
    </Box>
  );
};
